import api from '@/utils/api';

export function getPromotions() {
  return api
    .get('api/v1/promotions/active/')
    .then(({ data }) => {
      if (!Object.keys(data).length) return {};

      const { top_purple_bar: bar, gateway, popup, top_nav: topNav, landing_page_hero: landingPageHero } = data;
      return {
        topPurpleBar: {
          link: bar?.link,
          text: bar?.desktop_text,
          mobileText: bar?.mobile_text,
        },
        landingPageHero: landingPageHero ?? null,
        gateway: gateway ?? null,
        popup: popup ?? null,
        topNav: topNav ?? null,
      };
    })
    .catch(error => {
      console.error('ERROR FETCHING PROMOTIONS:', error);
      return {};
    });
}
